<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="imei-input-modal"
        ok-disabled
        ref="imei-input-modal"
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                Provide your IMEI number
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <div class="alert alert-info text-sm" v-if="carrierDetails.hasCallOutCharge">
                <div class="alert-content">Supplying your IMEI allows us to validate the device's model and colour. If you have booked in an incorrect model and do not supply an IMEI, you will be subject to a <strong><span v-html='currencySymbol'></span>{{ carrierDetails.callOutCharge }} call-out fee</strong>. Enter your IMEI now to avoid this charge.</div>
            </div>
            <div class="form-group" :class="{ 'has-error' : errors[0] }">
                <label>Enter your IMEI</label>
                <input type="text" class="form-control" placeholder="IMEI Number" v-model="imei" />
                <p class="help-block text-danger" v-if="errors[0]">* {{ errors[0] }}</p>
            </div>
            <button class="btn btn-outline-secondary btn-block" v-b-toggle.imei-instructions>
                <i class="fa fa-info-circle mr-1"></i> How to find your IMEI number
            </button>
            <b-collapse id="imei-instructions">
                <p class="text-sm mt-3">
                    An IMEI number is a unique code (normally 15 digits) to identify the exact model of device. Providing your IMEI number ensures the technicians are equipped with the exact parts required. There are a few different ways you can find it:
                </p>
                <ol class="text-sm">
                    <li>
                        <strong>Dial the code:</strong> Dial <pre class="d-inline">*#06#</pre> using your handset's keypad.
                    </li>
                    <li>
                        <div>
                            <strong>On iPhone:</strong> Go to <pre class="d-inline">Settings > General > About</pre>.
                        </div>
                        <div>
                            <strong>On Android:</strong> Go to <pre class="d-inline">Settings > About Phone > Status</pre>.
                        </div>
                    </li>
                    <li>
                        <strong>On the packaging:</strong> If you have the original packaging for your phone, you can find the IMEI number on the barcode label.
                    </li>
                </ol>
            </b-collapse>
            <!-- Footer buttons -->
            <template v-if="!saving">
                <button class="btn btn-success btn-block mt-4 btn-lg" @click="saveImei()">Add IMEI</button>
                <button class="btn btn-link btn-block" @click="$bvModal.hide('imei-input-modal')">Cancel</button>
            </template>
            <button v-else class="btn btn-success btn-lg btn-block mt-4 disabled"><animated-loading class="mr-2" size="sm"></animated-loading> Updating...</button>
        </div>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        props:["deviceId", "order"],

        data() {
            return {
                errors: [],
                imei: "",
                saving: false
            }
        },

        computed: {
            ...mapGetters([
                'carrierDetails',
                'currencySymbol'
            ])
        },

        methods: {
            ...mapActions([
                "displayToast",
                "setOrderDeviceImei"
            ]),

            saveImei() {
                this.errors = [];
                this.saving = true;

                this.setOrderDeviceImei({
                    deviceId: this.deviceId,
                    imei: this.imei,
                    order: this.order
                }).then(() => {
                    this.$bvModal.hide('imei-input-modal');
                    this.saving = false;
                    this.displayToast({text: 'IMEI added', type: 'success'});
                    this.$emit("imei-added");
                }).catch(errors => {
                    this.saving = false;
                    if (errors.response.data.messages.imei) {
                        this.errors = errors.response.data.messages.imei;
                    } else {
                        this.errors = errors.response.data.messages;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>